// Rxjs imports
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
// Service imports
import { AuthService } from '../_services/auth.service';
import { RoutingHelperService } from '../_services/shared-services/routing-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../_services/auth.service";
import * as i2 from "../_services/shared-services/routing-helper.service";
export class DataGuard {
    constructor(authService, routingHelperService) {
        this.authService = authService;
        this.routingHelperService = routingHelperService;
        this.routed = false;
        this.allowAnonymous = false;
        this.outletOnly = false;
    }
    canActivate(route) {
        if (route.data.anonymousAccess) {
            this.routingHelperService.setAllowAnonymous(route.data.anonymousAccess);
        }
        if (route.data.outletOnly) {
            this.routingHelperService.setOutletOnly(route.data.outletOnly);
        }
        const userLoggedIn = this.authService.isLoggedIn;
        if (!userLoggedIn && this.authService.hasFormsAuthenticationCookie) {
            return this.authService.loginUsingFormsAuthentication().pipe(map(() => {
                // NOTE: This is not an authentication guard. It does not matter if login using forms authentication was successful or not.
                return true;
            }), catchError(() => {
                return of(true);
            }));
        }
        else {
            return true;
        }
    }
}
DataGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DataGuard_Factory() { return new DataGuard(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.RoutingHelperService)); }, token: DataGuard, providedIn: "root" });
